// extracted by mini-css-extract-plugin
module.exports = {"getStarted":"styles_getStarted__L_91c","getStarted__form":"styles_getStarted__form__HBUYR"};